
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/telecommunications",
      function () {
        return require("private-next-pages/cases/telecommunications/index.tsx");
      }
    ]);
  